var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-subtitle-1"},[_vm._v(_vm._s(_vm.label)+": "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }